import { render } from "./delete-request.vue?vue&type=template&id=d6c2944c"
import script from "./delete-request.vue?vue&type=script&lang=js"
export * from "./delete-request.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__